import { Injectable } from '@angular/core';
import {  HttpGeneralService } from '../../shared/shared';
import { ResidenceDegree } from './residence-degree';
import { CONFIG } from '../../shared/config';

let residencedegreeUrl = CONFIG.baseUrls.residencedegree;

@Injectable()
export class ResidenceDegreeService {

    constructor(
        private httpGeneralService: HttpGeneralService
    ) { }


    getResidenceDegree(id: number) {
        return this.httpGeneralService.get(id, residencedegreeUrl)
    }

    addResidenceDegree(residencedegree: ResidenceDegree) {
        
        return this.httpGeneralService.add<ResidenceDegree>(residencedegree, residencedegreeUrl)
    }

    updateResidenceDegree(residencedegree: ResidenceDegree) {
        return this.httpGeneralService.update<ResidenceDegree>(residencedegree.serial, residencedegree, residencedegreeUrl)
    }

    deleteResidenceDegree(id: number) {
        return this.httpGeneralService.delete<number>(id, residencedegreeUrl)
    }
}

